/** АПИ для управления сотрудниками ведомств */

import { buildFetch, buildRequestBody } from "../utils";
import { getParamsGET_CITIES_JSON } from "./params";
import { IGetParamsGET_Cities_JSON, IResponseGetCities } from "./type";

const apiCities = {

    async getCities({
        NFIRST_ROWNUM = 0,
        NLAST_ROWNUM = 20000000,
        CFILTER = '',
        NID = null
    }: IGetParamsGET_Cities_JSON): Promise<IResponseGetCities> {
        const parameters = getParamsGET_CITIES_JSON({ NFIRST_ROWNUM, NLAST_ROWNUM, CFILTER, NID });
        const body = buildRequestBody({ parameters, object_name: "GET_CITIES_JSON" });
        const response = await buildFetch({ body })
        return response;  
    }
};

export default apiCities;
